// extracted by mini-css-extract-plugin
export var list = "posts-list-module--list--0dkMV";
export var paginationBox = "posts-list-module--pagination-box--ju23R";